import {ChangeDetectionStrategy, Component, inject, signal} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {MessageService, PrimeTemplate} from "primeng/api";
import {AsyncPipe, DatePipe} from "@angular/common";
import {TableModule} from "primeng/table";
import {ApartmentService} from "../../../services/apartment.service";
import {RouterLink} from "@angular/router";
import {TypedTableRowDirective} from "../../../typed-table-row.directive";

@Component({
  selector: 'app-apartments-tab',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    AsyncPipe,
    RouterLink,
    TypedTableRowDirective
  ],
  templateUrl: './apartments-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApartmentsTabComponent {
  protected readonly id = signal<string>('');
  protected readonly src = signal<string>('');

  private readonly httpClient = inject(HttpClient);
  private readonly messageService = inject(MessageService);
  private readonly apartmentService = inject(ApartmentService);
  protected readonly apartments$ = this.apartmentService.apartments$;

  onSubmit() {
    this.httpClient.put(`${environment.apiUrl}/api/private/apartments/${this.id()}/main-image`, {
      src: this.src()
    }).subscribe(
      () => this.messageService.add(
        { severity: 'success', summary: 'Success', detail: 'Image updated successfully' }
      )
    )
  }
}
